/** @format */

import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Cookies from "js-cookie";
import cloudIcon from "../../../../Assets/icons/cloud-add.png";
import FileIcon from "../../../../Assets/icons/pdf_file.png";

const PurchaseRequestViewAskQuo = ({}) => {
  const navigate = useNavigate();
  const [tName, settName] = useState("Supply Manager");
  const [proceedTo, setProceedTo] = useState("");
  const { REACT_APP_API_ENDPOINT } = process.env;
  const location = useLocation();
  const selectedRecord = location.state?.selectedRecord || {};
  const [tableData, setTableData] = useState(selectedRecord.pr_items || []);
  const userId = Cookies.get("employee_no");
  const currentDate = new Date(); // Get the current date and time
  const formattedDate = currentDate.toISOString().split("T")[0];
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviewsecond, setImagePreviewsecond] = useState(null);
  const [imagePreviewthired, setImagePreviewthired] = useState(null);
  const [supplierData, setSupplierData] = useState([]);

  console.log("selected Record", selectedRecord);
  console.log("selected Supplier", supplierData);

  // Define a function to fetch Procument item data
  const fetchProItemData = async () => {
    try {
      // Extract item IDs from procurement_items
      const itemIds = selectedRecord.pr_items.map((item) => item.item_id);

      // Fetch data for each item ID
      const fetchPromises = itemIds.map((itemId) =>
        fetch(`${REACT_APP_API_ENDPOINT}/v1/inventory/item/item/${itemId}`)
      );

      // Await all fetches
      const responses = await Promise.all(fetchPromises);

      // Parse all responses
      const dataPromises = responses.map((response) => response.json());
      const dataArray = await Promise.all(dataPromises);

      // Prepare table data based on fetched data
      const newTableData = dataArray.map((itemData, index) => {
        const procurementItem = selectedRecord.pr_items[index];
        return {
          item_id: itemData.item_id,
          item_name: itemData.item_name,
          item_measure_unit: itemData.item_measure_unit,
          item_category_name: itemData.item_category_name,
          item_sub_category_name: itemData.item_sub_category_name,
          total_shadow_qty: itemData.total_shadow_qty,
          item_qty: procurementItem.item_qty || 0, // Use item_qty from procurement_items if available
        };
      });

      // Update tableData state
      setTableData(newTableData);
    } catch (error) {
      console.error("Error fetching item data:", error);
    }
  };

  // Initialize state with selectedRecord image URLs
  useEffect(() => {
    if (selectedRecord) {
      setImagePreview(selectedRecord.ordered_img);
      setImagePreviewsecond(selectedRecord.approved_img);
      setImagePreviewthired(selectedRecord.prepared_img);
    }
  }, [selectedRecord]);

  useEffect(() => {
    if (selectedRecord.pr_items.length > 0) {
      fetchProItemData();
    }
  }, [selectedRecord.pr_items]);

  const handleSubmit = async (status) => {
    // Extract item IDs from procurement_items
    const supplierIds = supplierData.map((supplier) => supplier.supplier_id);
    // Body of the PUT request
    const requestBody = {
      pr_id: selectedRecord.pr_id,
      created_date: formattedDate,
      created_by: userId,
      suppliers: supplierIds,
    };
    console.log("req body", requestBody);
    try {
      // Making the PUT request using fetch
      const response = await fetch(
        `${REACT_APP_API_ENDPOINT}/v1/supplychain/quatation/add-quatation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      // Handle the response
      console.log("Response:", response.data);
      alert("Purchase Request email send successfully");
      handleReset();
    } catch (error) {
      // Handle errors
      console.error("Error:", error);
      alert("Failed to add Purchase Request");
    }
  };

  // Reset function
  const handleReset = () => {
    navigate(-1);
  };

  const handleReject = () => {};

  const fetchSupplierData = async () => {
    try {
      const response = await fetch(
        `${REACT_APP_API_ENDPOINT}/v1/supplyChain/supplier/category/${selectedRecord.category}`
      );
      const data = await response.json();

      setSupplierData(data);
      console.log("Suppliers data:", data);
    } catch (error) {
      console.error("Error fetching Suppliers data:", error);
    }
  };

  useEffect(() => {
    fetchSupplierData();
  }, []);

  const handleAddSubSupplier = () => {
    navigate("/suppliers/add");
  };

  return (
    <div className="bg-background overflow-y-auto h-screen relative">
      <div>
        <p className="text-[40px] font-sans ml-6 mt-[1%] font-bold text-[#071C50] ">
          View Purchase Request
        </p>
      </div>
      <div className="w-full flex items-center justify-center">
        <div className="bg-[#F3F8FF] rounded-[46px] border border-[#00000036] px-[200px] py-11 my-10 flex flex-col items-center justify-center">
          <p className="header-1 text-center">View Purchase Request</p>
          <div className="w-[600px] flex items-center justify-between my-10">
            <label className="label-1">PR No</label>
            <label className="label-1">:</label>
            <input
              className="input-1 border border-[#00000036]"
              type="text"
              value={selectedRecord.pr_id}
              disabled
            />
          </div>
          <div className="w-[600px] flex items-center justify-between my-10">
            <label className="label-1">Request Title</label>
            <label className="label-1">:</label>
            <input
              className="input-1 border border-[#00000036]"
              type="text"
              value={selectedRecord.title}
              disabled
            />
          </div>
          <div className="w-[600px] flex items-center justify-between my-10">
            <label className="label-1">From</label>
            <label className="label-1">:</label>
            <input
              className="input-1 border border-[#00000036]"
              type="text"
              value={selectedRecord.department_name}
              disabled
            />
          </div>
          <div className="w-[600px] flex items-center justify-between my-10">
            <label className="label-1">Subject</label>
            <label className="label-1">:</label>
            <input
              className="input-1 border border-[#00000036]"
              type="text"
              value={selectedRecord.category}
              disabled
            />
          </div>
          <div className="w-[600px] flex items-center justify-between my-10">
            <label className="label-1">To</label>
            <label className="label-1">:</label>
            <input
              className="input-1 border border-[#00000036]"
              type="text"
              value={tName}
              disabled
            />
          </div>
          <div className="w-[600px] flex items-center justify-between my-10">
            <label className="label-1">Request Date</label>
            <label className="label-1">:</label>
            <input
              className="input-1 border border-[#00000036]"
              type="text"
              value={selectedRecord.pr_date}
              disabled
            />
          </div>
          <div className="w-[600px] flex items-center justify-between my-10">
            <label className="label-1">Due Date</label>
            <label className="label-1">:</label>
            <input
              className="input-1 border border-[#00000036]"
              type="text"
              value={selectedRecord.required_date}
              disabled
            />
          </div>
        </div>
      </div>

      <p className="header-1 mb-10">Purchase Request Item Details</p>

      <div className="w-full flex items-center justify-center my-10">
        <div className="bg-[#F3F8FF] w-full min-h-96 mx-16 rounded-t-[40px] rounded-b-[50px]">
          <div className="w-full h-20 bg-PrimaryColor2 rounded-[100px] flex items-center justify-around">
            <p className="w-10 p1 text-[#656565] text-center">#</p>
            <div className="w-[350px] flex flex-col items-center">
              <p className="w-full p1 text-[#656565] text-center ">Item Name</p>
              <div className="border-[3px] border-[#656565] w-[67px] rounded-[100px] mt-1"></div>
            </div>
            <div className="w-[200px] flex flex-col items-center">
              <p className="w-full p1 text-[#656565] text-center ">
                Available Qty
              </p>
              <div className="border-[3px] border-[#656565] w-[67px] rounded-[100px] mt-1"></div>
            </div>
            <div className="w-[200px] flex flex-col items-center">
              <p className="w-full p1 text-[#656565] text-center ">
                Request Quantity
              </p>
              <div className="border-[3px] border-[#656565] w-[67px] rounded-[100px] mt-1"></div>
            </div>
            <div className="w-[200px] flex flex-col items-center">
              <p className="w-full p1 text-[#656565] text-center ">
                Item Category
              </p>
              <div className="border-[3px] border-[#656565] w-[67px] rounded-[100px] mt-1"></div>
            </div>
            <div className="w-[200px] flex flex-col items-center">
              <p className="w-full p1 text-[#656565] text-center ">
                Item Sub Category
              </p>
              <div className="border-[3px] border-[#656565] w-[67px] rounded-[100px] mt-1"></div>
            </div>
            <div className="w-[200px] flex flex-col items-center">
              <p className="w-full p1 text-[#656565] text-center ">
                Item Measure Unit
              </p>
              <div className="border-[3px] border-[#656565] w-[67px] rounded-[100px] mt-1"></div>
            </div>
          </div>
          <div className="flex flex-col gap-y-5 my-3 h-[250px] overflow-y-scroll">
            {tableData.length > 0
              ? tableData.map((item, index) => (
                  <div key={index} className="w-full  flex justify-around ">
                    <div className="w-10 flex text-center">
                      <p className="w-full p1 text-[#656565] text-center ">
                        {index + 1}
                      </p>
                    </div>
                    <div className="w-[350px] flex  text-center">
                      <p className="w-full p1 text-[#656565] text-center ">
                        {item.item_name}
                      </p>
                    </div>
                    <div className="w-[200px] flex  text-center">
                      <p className="w-full p1 text-[#656565] text-center ">
                        {item.total_shadow_qty}
                      </p>
                    </div>
                    <div className="w-[200px] flex text-center">
                      <p className="w-full p1 text-[#656565] text-center ">
                        {item.item_qty}
                      </p>
                    </div>
                    <div className="w-[200px] flex  text-center">
                      <p className="w-full p1 text-[#656565] text-centel ">
                        {item.item_category_name}
                      </p>
                    </div>
                    <div className="w-[200px] flex text-center">
                      <p className="w-full p1 text-[#656565] text-center ">
                        {item.item_sub_category_name}
                      </p>
                    </div>

                    <div className="w-[200px] flex  text-center">
                      <p className="w-full p1 text-[#656565] text-center ">
                        {item.item_measure_unit}
                      </p>
                    </div>
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>

      <div className=" flex items-center justify-center mt-5">
        <div>
          <h2 className="text-dialogHeader font-poppins font-semibold text-[26px] text-center">
            Uploaded File
          </h2>
          <hr className=" ml-[20%] w-[60%] border-solid border-b-2 border-black"></hr>
        </div>
      </div>
      <div className="bg-white justify-center items-center rounded-[26px] min-h-[400px] w-[80%] h-[60%] flex-shrink-0 mt-5 ml-[10%]">
        <main className="container mx-auto max-w-screen-lg h-full">
          <h1 className="pt-8 pb-3 font-semibold sm:text-lg text-gray-900">
            Uploaded File
          </h1>

          {/* Check if selectedRecord.pr_doc exists */}
          {selectedRecord.pr_doc ? (
            <div className="flex justify-center">
              <a
                href={`${REACT_APP_API_ENDPOINT}/v1/supplychain/purchaseRequest/file/${selectedRecord.pr_doc}`}
                download={selectedRecord.pr_doc} // Make the file downloadable
                className="cursor-pointer"
              >
                {/* Display the file icon or image */}
                <img
                  className="h-[100px] w-[100px] object-contain"
                  src={FileIcon}
                  alt="File Icon"
                />
              </a>
            </div>
          ) : (
            <p>No file uploaded</p>
          )}
        </main>
      </div>

      <div className="  grid grid-cols-3 ml-6 mt-6 ">
        {/* Drag and drop area */}
        <div className="flex flex-col items-center justify-center mt-6">
          {imagePreview ? (
            <div>
              <img
                src={imagePreview}
                alt="Order By"
                className="w-40 h-40 rounded-lg mb-4"
              />
              <p className="text-black font-semibold ml-9 mt-2 text-[20px]">
                Order By
              </p>
            </div>
          ) : (
            <div className="bg-white border border-gray-300 w-50 h-60 rounded-lg flex flex-col items-center justify-center mb-6">
              <p className="text-black font-bold ml-2 mt-2 text-[24px]">
                Order By
              </p>
              <img
                src={cloudIcon}
                alt="Cloud Icon"
                className="w-16 h-16 mb-2"
              />
              <p className="text-[#8691AB] font-bold ml-4">
                Drag and Drop Digital Signature
              </p>
            </div>
          )}
        </div>

        {/* Second Signature */}
        <div className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center">
            <img
              src={imagePreviewsecond}
              alt="Approved By"
              className="w-40 h-40 rounded-lg mb-4"
            />
            <p className="text-black font-semibold ml-5 mt-2 text-[20px]">
              Approved By
            </p>
          </div>
        </div>
        {/* Thiered Signature */}
        <div className="flex flex-col items-center justify-center mt-6">
          <div>
            <img
              src={imagePreviewthired}
              alt="Prepared By"
              className="w-40 h-40 rounded-lg mb-4"
            />
            <p className="text-black font-semibold ml-5 mt-2 text-[20px]">
              Prepared By
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white justify-center items-center rounded-[26px] min-h-[400px] w-[80%] h-[60%] flex-shrink-0 mt-5 ml-[10%] p-6">
        <h2 className="text-[20px] font-semibold text-gray-700 mb-4">
          Supplier List
        </h2>

        {/* Legend for Supplier Types */}
        <div className="flex items-center gap-6 mb-4 justify-center">
          {/* OPEN Supplier Legend */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-[#ffd000]"></div>
            <span className="text-gray-700 text-[14px]">Open Supplier</span>
          </div>

          {/* REGISTERED Supplier Legend */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-[#E1F0DA]"></div>
            <span className="text-gray-700 text-[14px]">
              Registered Supplier
            </span>
          </div>
        </div>
        {/* Flex container for suppliers list and button */}
        <div className="flex flex-wrap gap-4 justify-center">
          {supplierData.map((item, index) => (
            <div
              key={index}
              className={`flex items-center justify-between text-[14px] rounded-lg p-4 w-[45%] shadow-md ${
                item.supplier_type === "OPEN" ? "bg-[#ffd000]" : "bg-[#E1F0DA]"
              }`}
            >
              {/* Display the supplier ID and Name */}
              <div className="font-medium text-gray-900">
                {item.supplier_id} - {item.supplier_name}
              </div>
            </div>
          ))}
        </div>

        {/* Flexbox to align button to the right */}
        <div className="flex justify-end mt-5">
          <button
            onClick={handleAddSubSupplier}
            className="bg-[#99BC85] text-white h-[30px] w-[200px] rounded-md"
          >
            Add New Supplier
          </button>
        </div>
      </div>

      <div className="w-full flex items-center justify-end gap-x-6 my-10 px-16">
        <button
          className="text-black font-bold text-2xl py-2 px-4 rounded-lg bg-transparent border border-black"
          onClick={handleReset}
        >
          Cancel
        </button>
        <>
          <button
            onClick={() => handleReject()}
            className="bg-[#AA4343] hover:bg-[#bc4749] text-white font-bold text-2xl py-2 px-4 rounded-lg"
          >
            Rejected
          </button>
          <button
            onClick={() => handleSubmit("APPROVED")}
            className="bg-[#5B6D49] hover:bg-[#495e33] text-white font-bold text-2xl py-2 px-4 rounded-lg"
          >
            Send mail for Suppliers
          </button>
        </>
      </div>
    </div>
  );
};

export default PurchaseRequestViewAskQuo;
